import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function getReasonsForResignation(companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/resignations/reasons?company_id=${companyId}&type=Resignation&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getEmpBoarding(companyId: number, empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpOffBoarding?company_id=${companyId}&emp_id=${empId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getEmpBoardingWithdrawn(companyId: number, empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpOffBoardingWithDrawn?company_id=${companyId}&emp_id=${empId}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function addEmpBoarding(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/offboard/create`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function withdrawEmpBoarding(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/offboard/withdraw`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const offBoardingService = {
  getReasonsForResignation,
  getEmpBoarding,
  getEmpBoardingWithdrawn,
  addEmpBoarding,
  withdrawEmpBoarding,
};
